/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SortingInputs */

const en__field_sorting = /** @type {(inputs: _Field_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Sorting`)
};

const de__field_sorting = /** @type {(inputs: _Field_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortierung festlegen`)
};

/**
* | output |
* | --- |
* | "Set Sorting" |
*
* @param {_Field_SortingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_sorting = /** @type {((inputs?: _Field_SortingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SortingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sorting(inputs)
	return de__field_sorting(inputs)
});